import { Center, Loader } from '@mantine/core';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/useAuth';

interface Props {
  children: React.ReactNode;
}

/** Redirects anonymous users to /login while preserving the intended path. */
export function ProtectedRoute({ children }: Props) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <Center mih="60vh" role="status" aria-label="Checking session">
        <Loader color="forge" size="md" />
      </Center>
    );
  }
  if (status === 'anonymous') {
    // Silent redirect — the destination /login page exposes context via its
    // page <h1> and Seo title; an aria-live announcement here would fire on
    // first visit too, which is noisier than helpful.
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
